enum Constants {
  LOGGED_IN_TOKEN = "LOGGED_IN_TOKEN",
  REGISTERED_USER_ERROR= "You are already registered. Please login!",

}
export default Constants;
